var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-right-lang-btn",class:_vm.lang,on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}})}
var staticRenderFns = []

export { render, staticRenderFns }